<template lang="pug">
  include ./../../../mixins
  div
    router-module()
    +b.pa--t_md.--b_md.SECTION
      +b.ug-container--variant_large
        +b.ma--b_xs.TEXT-BEMTO(
          :fw="'bold'"
          :lh="'initial'"
          :fs="'xl'"
          :color="'black'"
          :tag="'p'"
        ) PROFILE
        +b.bg--white.pa--f_1sm.--f_md-md
          +b.ug-row--apearance_spaced.--space_md
            +b.ug-cell.ug-cols--12.--10-lg.--8-xl.--7-mac
              common-change()
        +b.bg--white.pa--r_1sm.--r_md-md.--b_1sm.--b_md-md.--l_1sm.--l_md-md
          +b.ug-row--apearance_spaced.--space_md
            +b.ug-cell.ug-cols--12.--10-lg.--8-xl.--7-mac
              email-panel()
        +b.bg--white.pa--r_1sm.--r_md-md.--b_1sm.--b_md-md.--l_1sm.--l_md-md
          +b.ug-row--apearance_spaced.--space_md
            +b.ug-cell.ug-cols--12.--10-lg.--8-xl.--7-mac
              password-panel()
</template>

<script>
export default {
  name: 'SettingsCabinet',
}
</script>



// WEBPACK FOOTER //
// src/js/components/Pages/Cabinet/SettingsCabinet.vue